import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Button,IconButton,Stack,TextField } from '@mui/material';
import React,{ useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RiErrorWarningFill } from 'react-icons/ri';
import { useNavigate,useParams } from 'react-router-dom';
import { toast,ToastContainer } from 'react-toastify';
import AxymaLogo from '../assets/images/Axyma_branco.svg';
import Logo from "../assets/images/logo-login.png";
import { Box,SmallText,UnderLogoText } from '../components/FormLogin/FormLoginStyle';
import Loading from '../components/Loading/Loading';
import { trackEventMatomoVisit } from '../helpers/matomo';
import Login from '../service/Login';

const loginService = new Login();

export default function Recuperacao() {
  const [loading, setLoading] = useState(false);
  const [inputType, setInputType] = useState("password");
  const toggleEye = () => inputType === "password" ? setInputType("text") : setInputType("password");
  const [password, setPassword] = useState("");
  const [validPassword, setValidPassword] = useState<string>('');

  useEffect(() => {
    trackEventMatomoVisit('Recuperação de senha');
  }, []);

  const validatePassword = () => {
    if (password !== validPassword) {
      return (
        <>
          <span style={{
            color: 'white',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            margin: 0,
            padding: 0,
            alignItems: 'center'
          }}>{t('users.userRegister.passwordWarning')}<RiErrorWarningFill /></span>
        </>
      );
    } else return (<div style={{ height: '22px' }}></div>);
  };

  const { t } = useTranslation('translation');

  const { uid } = useParams();

  const now = new Date();

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const toastId = toast.loading(`${t('loginScreen.Recuperacao.resettingPassword')}`, { isLoading: true });
    setLoading(true);

    const result = await loginService.resetPassword({ uid: uid as string, password });
    if (!result) {
      toast.error(`${t('loginScreen.Recuperacao.errorChangingPassword')}`);
    } else if (result.success) {
      toast.success(`${t('loginScreen.Recuperacao.passwordChangedSuccessfully')}`);
      setPassword('');
      navigate('/login');
    } else {
      toast.error(result.message, { toastId: String(result.message).substring(0, 20) });
    }
    setLoading(false);
    toast.dismiss(toastId);
    return result;
  };

  return loading ? (<div style={{
    backgroundColor: '#3a1c64',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  }}>
    <img src={AxymaLogo} alt="logo axyma branco" width={'40%'} />
    <Loading />
  </div>) : (
    <Stack
      width="100%"
      height="100svh"
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        background: 'linear-gradient(to right, #9a72c9, #612a79)',
      }}
    >
      <ToastContainer />
      <Box>
        <Stack
          direction="column"
          spacing={1}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            color: 'white',
            paddingTop: '10px'
          }}
          width='250px'>

          <img width="150px" alt="Axyma" src={Logo} style={{ borderRadius: '5px', filter: 'contrast(150%)' }} />
          <UnderLogoText>Alterar Senha</UnderLogoText>
          <form onSubmit={handleSubmit} autoComplete="off" style={{ width: '100%' }}>
            <Stack
              direction="column"
              spacing={1}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack
                direction="row"
                spacing={0.5}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <TextField
                  InputProps={{ style: { backgroundColor: 'white' } }}
                  size="small"
                  fullWidth
                  variant='filled'
                  required
                  type={inputType}
                  label={t('loginScreen.password')}
                  value={password}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value.trim())}
                />
                <IconButton sx={{ color: 'white' }} onClick={toggleEye}>
                  {inputType === "password" ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )
                  }
                </IconButton>
              </Stack>
              <TextField
                fullWidth
                variant='filled'
                InputProps={{ style: { backgroundColor: 'white' } }}
                size="small"
                label={t('users.userRegister.confirmation')}
                autoComplete='new-password'
                type={inputType}
                value={validPassword}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValidPassword(e.target.value.trim())}
                required
              />
              <Button
                variant='contained'
                endIcon={<ChangeCircleIcon />}
                disabled={loading
                  || (password !== validPassword)
                  || !validPassword.length
                  || !password.length}
                type='submit'
                className='button is-white'
              >
                {t('loginScreen.Recuperacao.change')}
              </Button>
              {validPassword.length > 0 &&
                validatePassword()}
            </Stack>
          </form>
          <SmallText>Axyma @ {now.getFullYear()}</SmallText>
        </Stack>
      </Box>
    </Stack>
  );
}
